module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"BreadcrumbFirstItem":{"text":"E-shop"}},"en":{"BreadcrumbFirstItem":{"text":"Home"}}}')
  delete Component.options._Ctor
}
